module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAsUlEQVQokZWSwQ3CMAxFn6OcGIAjGzBDzl2h3JFgIwZggzJBOTIDEhw6AOKIFA51aFo1Br5kJd/fsh07EkIV6SF6Jn4HVgwY6U4dMgn4yl1W4R9Eb4hnYFkS/aSNHBsjqThDrIFtSUxvTNaqfwccgYP6a/W3KTZVvKp1yh/AK9Oeeu+UIyFUpW5u9HucnYE11T2wKIlee57LejKSRmuqDXCxKpb2uGb8V3NIvo5PG7/wNz8cKUPmqfY+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/12c.png
// module id = I2H5
// module chunks = 64